import { Outlet } from 'react-router-dom'
import { Header } from '@/components/blocks/header/header'
import { Footer } from '@/components/blocks/footer/footer'
import { CookieConsent } from '@/components/blocks/cookie-consent'
import { NetworkBackground } from '@/components/network-background'
import { ConnectChatWidget } from '@/components/connect-chat-widget'

export function RootLayout() {
  return (
    <div className="relative flex min-h-screen flex-col bg-neutral-950">
      <NetworkBackground />
      <div className="relative z-10 flex min-h-screen flex-col">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <CookieConsent />
        <ConnectChatWidget />
      </div>
    </div>
  )
}
